import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/apps/backoffice-app/components/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Fraunces\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"500\",\"600\"],\"variable\":\"--font-fraunces\"}],\"variableName\":\"fraunces\"}");
;
import(/* webpackMode: "eager" */ "/app/packages/configs/styles.css");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/index.tsx");
